import classnames from 'classnames';
import { FunctionComponent } from 'react';

type TwitterProps = {
    className?: string;
};

const Twitter: FunctionComponent<TwitterProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'twitter'}
            viewBox="0 -40 613 613"
        >
            <path d="M0 441.8h29.9c60.4 0 113.8-16.8 160.1-50-53.7-1.2-99.2-39-120.2-91.2 5.8 3.3 13.7 5.2 23.2 5.2 3.9 0 10.4-1 18.9-2.7 8.2-1.5 14-2.5 17.4-2.5-60.1-10.1-105-60.7-105-123 17.4 7 22.3 9.4 36.9 12.1 7.3 1.5 15 2.1 22.9 2.1-35.1-22-59.8-61.9-59.8-101.3 0-30.2 5.2-48.2 19.9-68.7 60.7 78.5 154.6 127.9 255 134.9 0-3.9-.4-9.2-.6-15.6-.4-6.4-.6-11-.6-14.3 0-45.5 25.4-87.5 63.5-110.1C380.7 5.5 400.8 0 422.3 0c34.8 0 67.1 13.5 97 40.6 17-2.1 33-8.2 55.2-18.3 11-5.2 18.9-8.6 23.5-10.4-9.4 27.1-28.1 46.7-60.1 68.9 29.6-3.1 54.6-10.1 75-20.7-13.1 22.9-32.6 45.1-58.6 66.8v15c0 54.9-15.2 112.3-42.4 165.6-27.1 53.3-71.1 101-122.6 136.1S268.5 500 194.3 500C123.8 500 58.9 480.5 0 441.8z" />
        </svg>
    );
};
export default Twitter;
